import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks } from '@/mocks/articles';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center">
              <i className={`ri-fire-fill text-2xl md:text-3xl ${isScrolled ? 'text-primary-500' : 'text-primary-400'}`}></i>
            </div>
            <span className={`text-lg md:text-xl font-heading font-bold tracking-wide whitespace-nowrap ${
              isScrolled ? 'text-foreground-950' : 'text-white'
            }`}>
              爆瓜网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.href
                    ? isScrolled
                      ? 'bg-primary-500 text-white'
                      : 'bg-white/20 text-white'
                    : isScrolled
                      ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#download"
              className={`px-5 py-2 text-sm font-semibold rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'bg-foreground-950 text-background-50 hover:bg-foreground-800'
                  : 'bg-white text-foreground-950 hover:bg-white/90'
              }`}
            >
              APP下载 <i className="ri-arrow-right-line ml-1"></i>
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-full transition-colors cursor-pointer ${
              isScrolled ? 'text-foreground-950 hover:bg-background-100' : 'text-white hover:bg-white/10'
            }`}
            aria-label="切换菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`flex items-center gap-3 px-4 py-3 text-sm font-medium rounded-lg transition-colors cursor-pointer ${
                  location.pathname === link.href
                    ? 'bg-primary-500 text-white'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`}
              >
                <i className={`${link.icon} text-base w-5 h-5 flex items-center justify-center`}></i>
                {link.name}
              </Link>
            ))}
            <a
              href="#download"
              className="flex items-center justify-center gap-2 mt-2 px-4 py-3 text-sm font-semibold rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
            >
              APP下载 <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}